export enum PetColorKey {
  BLACK = "BLACK",
  WHITE = "WHITE",
  BROWN = "BROWN",
  TAN = "TAN",
  FAWN = "FAWN",
  RED = "RED",
  GOLDEN = "GOLDEN",
  CREAM = "CREAM",
  YELLOW = "YELLOW",
  ORANGE = "ORANGE",
  GRAY = "GRAY",
  BLUE = "BLUE",
  SILVER = "SILVER",
  CHOCOLATE = "CHOCOLATE",
  LIVER = "LIVER",
  APRICOT = "APRICOT",
  SABLE = "SABLE",
  BRINDLE = "BRINDLE",
  MERLE = "MERLE",
  TRICOLOR = "TRICOLOR",
  MULTICOLOR = "MULTICOLOR",
}
